export const getSuitableLayoutType = (
    deviceCount: number,
): '2x2' | '1х5' | '3х4' | '3х3' | '2х8' | '1х12' | '4х4' | '1х7' => {
    const layoutTypes: {
        type: '2x2' | '1х5' | '3х4' | '3х3' | '2х8' | '1х12' | '4х4' | '1х7';
        max: number;
    }[] = [
        { type: '2x2', max: 4 },
        { type: '1х5', max: 6 },
        { type: '3х3', max: 9 },
        { type: '3х4', max: 7 },
        { type: '1х7', max: 8 },
        { type: '2х8', max: 10 },
        { type: '1х12', max: 13 },
        { type: '4х4', max: 16 },
    ];

    // Сортируем по возрастанию максимального количества
    layoutTypes.sort((a, b) => a.max - b.max);

    // Находим первый тип, который вмещает все устройства
    const suitableType = layoutTypes.find((layout) => layout.max >= deviceCount);

    // Если устройств больше чем максимальная раскладка - возвращаем самую большую
    return suitableType?.type || '4х4';
};
